import { Navbar } from "../components/Navbar";
import { Film, Play } from "lucide-react";

const AUTH_BG =
  "https://images.unsplash.com/photo-1496559249665-c7e2874707ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxjaW5lbWF0aWMlMjB5b3V0aCUyMGZpbG0lMjBwaG90b2dyYXBoeXxlbnwwfHx8fDE3ODE1NjA0NDV8MA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white" data-testid="login-page">
      <Navbar />
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-screen pt-16">
        {/* LEFT */}
        <div className="flex items-center justify-center px-6 sm:px-12 py-20">
          <div className="max-w-md w-full cinema-fade-in">
            <div className="flex items-center gap-3 mb-12">
              <Film className="w-5 h-5 text-[#FF2A2A]" />
              <span className="font-mono text-xs uppercase tracking-[0.4em] text-white/50">
                Premiering · You
              </span>
            </div>

            <h1 className="font-display font-black text-5xl sm:text-6xl tracking-tighter leading-none">
              Sign in to start
              <br />
              your <span className="text-[#FF2A2A]">trailer.</span>
            </h1>

            <p className="font-emotional text-xl text-white/60 mt-6 leading-snug">
              One tap. No passwords. Your life, scored by AI.
            </p>

            <button
              onClick={handleGoogleLogin}
              data-testid="google-signin-button"
              className="group mt-12 w-full inline-flex items-center justify-center gap-3 bg-white text-black hover:bg-white/90 font-mono uppercase tracking-widest text-sm px-6 py-5 transition-colors"
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Continue with Google
            </button>

            <div className="mt-8 flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.3em] text-white/30">
              <Play className="w-3 h-3" />
              Rated E for Emotional. 16+
            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="relative hidden lg:block overflow-hidden">
          <img src={AUTH_BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-l from-transparent to-[#050505]/60" />
          <div className="absolute bottom-12 left-12 right-12">
            <p className="font-emotional text-3xl text-white leading-snug max-w-md">
              {`"This was the year everything changed."`}
            </p>
            <div className="font-mono text-xs uppercase tracking-[0.3em] text-white/50 mt-4">
              — Trailer 03 · Senior Year
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
